export const staircaseConfig = {
    gameSlug: 'speed-match',
    category: 'feu_vivacite',
    variable: 'duration_ms',
    startValue: 800,
    minValue: 350,
    maxValue: 1500,
    stepSizesByPhase: [80, 40, 25, 15],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'down-easier',
};
/**
 * Set complet de symboles, ordonne par croissance perceptive (12 = limite vivacite).
 * Niveau N utilise SYMBOLS.slice(0, setSize).
 */
export const SYMBOLS = [
    '◆', // ◆
    '●', // ●
    '▲', // ▲
    '■', // ■
    '★', // ★
    '✦', // ✦
    '◯', // ◯
    '☂', // ☂
    '✿', // ✿
    '☘', // ☘
    '☾', // ☾
    '☼', // ☼
];
function buildVariant(level) {
    if (level <= 10) {
        return { level, setSize: 4, label: 'Discrimination simple' };
    }
    if (level <= 20) {
        return { level, setSize: 6, label: 'Charge perceptive' };
    }
    if (level <= 30) {
        return { level, setSize: 8, label: 'Hick load' };
    }
    if (level <= 40) {
        return { level, setSize: 10, label: 'Pression set' };
    }
    return { level, setSize: 12, label: 'Limite vivacite' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase. */
export const timing = {
    fixationMs: 300,
    feedbackMs: 400,
    itiMs: 350,
};
export const paradigmMeta = {
    slug: 'speed-match',
    paradigm: '1-back perceptual discrimination (Hick 1952)',
    masterMage: 'Embra (feu-vivacite)',
    category: 'feu_vivacite',
    goal: 'Vitesse de discrimination perceptive : sport, tri visuel, conduite.',
};
//# sourceMappingURL=params.js.map